<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Campaign Terms and Conditions</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Campaign Terms and Conditions</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card-body">
          <div class="form-group">
            <label>Title</label>
            <input type="text" v-model="title" class="form-control" />
          </div>

          <div class="form-group">
            <label>Content</label>
            <div id="app">
              <ckeditor
                :editor="editor"
                v-model="content"
                :config="editorConfig"
              ></ckeditor>
            </div>
          </div>

          <button class="btn btn-primary" @click="updateContent">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "campaign",

  components: {
    ckeditor: CKEditor.component
  },

  data() {
    return {
      title: "",
      content: "",
      editor: ClassicEditor,
      editorConfig: {}
    };
  },

  methods: {
    loadCampaign() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/campaigns", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.title = res.data.data.title
            this.content = res.data.data.content
          });
      }
    },

    updateContent() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/campaigns",
            {
              _method: "PATCH",
              title: this.title,
              content: this.content,
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.loadCampaign();

            swal({
              text: res.data.message,
              icon: res.data.success ? 'success' : 'error',
              button: "OK"
            });
          });
      }
    }
  },

  mounted() {
    this.loadCampaign();
  }
};
</script>

<style>
.active {
  background: none;
}
</style>
